import dayjs, { dateTimeDisplayFormat } from '~libs/dayjs';
import { Column, Row } from '~components/table-view';

import MandateActions from '~direct-debits/components/mandates/MandateActions';
import MandateStatusBadge from '~direct-debits/components/mandates/MandateStatusBadge';

import { GocardlessMandate } from '~direct-debits/models';

interface ColumnFactoryCallbacks {
  onLink?: (mandate: GocardlessMandate) => void;
  onIgnore?: (mandate: GocardlessMandate) => void;
  onRestore?: (mandate: GocardlessMandate) => void;
  onUnlink?: (mandate: GocardlessMandate) => void;
  isBusy?: boolean;
  isConnected?: boolean;
}

const formatCreatedAt = (value: string | null | undefined): string => {
  if (!value) return '—';
  const parsed = dayjs(value);
  if (!parsed.isValid()) return '—';
  return parsed.format(dateTimeDisplayFormat);
};

export const columnsFactory = (callbacks: ColumnFactoryCallbacks = {}): Column[] => [
  {
    id: 'customer_name',
    header: 'Customer Name',
    type: 'text',
    sortable: true,
    deriveValue: (row) => row.customer_name || '—',
  },
  {
    // Customer-set reference returned by GoCardless. The new internal
    // DDM-NNNNNN identifier (`row.reference`) is intentionally not surfaced
    // here — its primary use is operator/support correlation, not matching.
    id: 'gocardless_reference',
    header: 'Reference',
    type: 'text',
    deriveValue: (row) => row.gocardless_reference || '—',
  },
  {
    id: 'status',
    header: 'Status',
    type: 'custom',
    component: MandateStatusBadge,
    classNames: {
      header: 'cell-align-center',
      column: 'cell-align-center',
    },
  },
  {
    id: 'created_at',
    header: 'Created',
    type: 'text',
    sortable: true,
    deriveValue: (row) => formatCreatedAt(row.created_at),
    classNames: {
      header: 'cell-align-center',
      column: 'cell-align-center',
    },
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: MandateActions,
    componentProps: callbacks,
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
];

export type MandateRow = Row & GocardlessMandate;
